import { mapAsset } from '@websrc/DataMappers/mapAsset'
import { CSProductDetails } from '@websrc/Typings/ContentStack'
import { createContext, useContext } from 'react'

export type ProductMeta = {
  product_number: string
  name: string
  url: string
  image?: ReturnType<typeof mapAsset>
  number_of_students?: number | null
  product_status: CSProductDetails['product_status']
  type: string
  grade: string
  embargo_date: CSProductDetails['embargo_date']
  back_order_date: CSProductDetails['back_order_date']
  is_retired: boolean
  sku_number: string
  channelsight_asset_id: string | null | undefined
  channelsight_virtual_sku: string | null | undefined
}

export type CoralProductMeta = {
  product_number: string
  name: string
  url: string
  image?: ReturnType<typeof mapAsset>
  product_status: CSProductDetails['product_status']
  embargo_date: CSProductDetails['embargo_date']
  back_order_date: CSProductDetails['back_order_date']
  is_retired: boolean
  sku_number: string
  channelsight_asset_id: string | null | undefined
  channelsight_virtual_sku: string | null | undefined
}

export type ProductMetaState = {
  [key: string]: ProductMeta
}

export type CoralProductMetaState = {
  [key: string]: CoralProductMeta
}

export const ProductMetaContext = createContext<ProductMetaState>({})
export const CoralProductMetaContext = createContext<CoralProductMetaState>({})

export const useProductMeta = (productNumber: string | number) => {
  const productMetaState = useContext(ProductMetaContext)

  return (
    productMetaState[`${productNumber}`] ?? {
      name: 'Unknown product',
      product_number: '',
      url: '',
    }
  )
}

export const useCoralProductMeta = (productNumber: string | number) => {
  const coralProductMetaState = useContext(CoralProductMetaContext)

  return (
    coralProductMetaState[`${productNumber}`] ?? {
      name: 'Unknown product',
      product_number: '',
      url: '',
    }
  )
}
